/***
 *
 *   TICKET DETAILS HEADER STYLES
 *
 **********/

const Style = {
    header: 'shrink-0 border-b border-border bg-surface/60',
    topRow: 'flex items-center gap-2 px-4 py-2.5 sm:px-6',

    chips: 'flex min-w-0 flex-wrap items-center gap-1.5',
    overdue: `inline-flex items-center gap-1 rounded-md border border-error/35 bg-error/10 px-2 py-0.5
        text-xs font-medium text-error`,
    archived: `inline-flex items-center gap-1 rounded-md border border-border bg-muted px-2 py-0.5
        text-xs font-medium text-text-muted`,
    actions: 'ml-auto flex shrink-0 items-center gap-1',

    identity: 'px-4 pb-4 pt-1 sm:px-6',
    subject: 'text-xl font-semibold leading-snug text-text-primary sm:text-2xl',
    meta: 'mt-2.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-text-muted',
    metaItem: 'inline-flex items-center gap-1.5',
    metaAvatar: 'h-5 w-5',
    metaText: 'text-text-secondary',
    metaStrong: 'font-medium text-text-primary',
    metaTime: 'text-xs text-text-muted',
};

export default Style;
